module.exports = __webpack_public_path__ + "static/media/kettlebell.e72a8ccd.png";